export default (options) => {
	const snackbarContainer = document.querySelector('.mdl-js-snackbar');

	const isSnackbarReady = () => window.MaterialSnackbar && snackbarContainer.MaterialSnackbar;

	const initSnackbar = () => {
		const snacks = Array.isArray(options) ? options : [options];

		return snacks.map((snack) => {
			const snackbarOptions = typeof snack === 'string' ? { message: snack } : snack;
			/* Default way of showing snackbar, sets a timeout to hide it which cannot be disabled
				snackbarContainer.MaterialSnackbar.showSnackbar(snackbarOptions);
			*/
			const { actionHandler, actionText, message } = snackbarOptions;

			const hasActionAndText = typeof actionHandler === 'function' && typeof actionText === 'string' && actionText.trim().length > 0;

			const snackBarText = snackbarContainer.querySelector('.mdl-snackbar__text');
			snackBarText.textContent = message;

			const	snackBarActionButton = snackbarContainer.querySelector('.mdl-snackbar__action');

			snackBarActionButton.textContent = hasActionAndText ? actionText : 'Close';
			snackbarContainer.removeAttribute('aria-hidden');
			snackBarActionButton.removeAttribute('aria-hidden');
			snackBarActionButton.removeAttribute('tabindex');
			snackBarActionButton.onclick = () => {
				if (hasActionAndText) {
					actionHandler();
				}
				if (snackbarContainer.MaterialSnackbar.cleanup_) {
					snackbarContainer.MaterialSnackbar.cleanup_();
				} else {
					snackbarContainer.classList.remove('mdl-snackbar--active');
				}
				snackBarActionButton.setAttribute('tabindex', '-1');
			};
			snackbarContainer.classList.add('mdl-snackbar--active');
		});
	};

	if (isSnackbarReady()) {
		initSnackbar();
	} else {
		const snackCheck = setInterval(() => {
			// ensure that material design scripts have been executed
			if (isSnackbarReady()) {
				clearInterval(snackCheck);
				initSnackbar();
			}
			return null;
		}, 1000);
	}
};



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/wmNotify.js